import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { stringify } from 'query-string';
import PropTypes from 'prop-types';
import { formatToCurrency, currencyToSign, clearEmptyParams } from '../../utils/utils';
import { setHeaderCurrency } from '../../actions/app';
import { startSetDashboardSummary } from '../../actions/dashboard';

const propTypes = {
  balance: PropTypes.array.isRequired,
};

const defaultProps = {
  leads: 0,
  sum: [],
  balance: [
    {
      balance: 0,
      currency: '',
      hold: 0,
    },
  ],
};

const getPreparedIfLongBalance = (value) =>
  `${value}`.length > 5 ? [value, '0,0'] : [value, '0,0.00'];

const BalanceWidget = ({ balance }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const headerCurrency = useSelector((state) => state.app.headerCurrency);
  const sum = useSelector((state) => state.dashboard.sum);
  const leads = useSelector((state) => state.dashboard.leads);

  useEffect(() => {
    dispatch(startSetDashboardSummary());
  }, []);

  useEffect(() => {
    const defaultCurrency = localStorage.getItem('defaultCurrency');
    if (defaultCurrency && balance.length > 1) {
      dispatch(setHeaderCurrency(Number(defaultCurrency)));
    }
  }, [balance, dispatch]);

  const account = balance[headerCurrency] || defaultProps.balance[0];

  const handleBalanceClick = (path, e) => {
    e.preventDefault();
    e.stopPropagation();
    history.push({
      pathname: '/profile/payments',
      search: `?${stringify(clearEmptyParams({ tab: path }))}`,
    });
  };

  return (
    <div className="balance-widget">
      <p className="balance-title">
        <FormattedMessage id="account.balance" defaultMessage="Balance" />
      </p>

      <div className="balance-widget-row">
        <button
          className="balance-widget-col"
          onClick={(e) => handleBalanceClick('', e)}
          onKeyPress={(e) => e.key === 'Enter' && handleBalanceClick('', e)}
          type="button"
        >
          <span className="balance-label">
            <FormattedMessage id="account.balance" defaultMessage="Balance" />
          </span>
          <span className="balance-value">
            {formatToCurrency(...getPreparedIfLongBalance(account.balance))}
            &nbsp;
            {currencyToSign(account.currency)}
          </span>
        </button>
        <button
          className="balance-widget-col"
          onClick={(e) => handleBalanceClick('hold', e)}
          onKeyPress={(e) => e.key === 'Enter' && handleBalanceClick('hold', e)}
          type="button"
        >
          <span className="balance-label">
            <FormattedMessage id="account.hold" defaultMessage="Hold" />
          </span>
          <span className="balance-value">
            {formatToCurrency(...getPreparedIfLongBalance(account.hold))}
            &nbsp;
            {currencyToSign(account.currency)}
          </span>
        </button>
      </div>

      <p className="balance-title">
        <FormattedMessage id="widgets.summary.title" defaultMessage="Summary for today" />
      </p>

      <div className="balance-conversions">
        <span>
          <FormattedMessage id="widgets.summary.conversions" defaultMessage="Conversions" />
        </span>
        <span className="balance-conversions-value">{leads}</span>
      </div>

      <div className="balance-earned">
        <span>
          <FormattedMessage id="widgets.summary.earned" defaultMessage="You've earned" />
        </span>
        <span className="balance-earned-value">{formatToCurrency(sum?.[0] || 0)} ₽</span>
      </div>
    </div>
  );
};

BalanceWidget.propTypes = propTypes;
BalanceWidget.defaultProps = defaultProps;

export default BalanceWidget;
